module.exports = __webpack_public_path__ + "assets/img/b002.5792fd9a.png";